import {TElement} from '@platform';

import {TFocusableNodeType} from '../../../../Tree/Constants/FocusableNodeType';
import FocusableComponentRenderStatus, {
    TFocusableComponentRenderStatus,
} from '../Constants/FocusableComponentRenderStatus';
import TUseFocusOptions from '../Types/TUseFocusOptions';

class UseFocusMutableState<T extends TFocusableNodeType> {
    public focusableElement: TElement | null = null;
    public options: Partial<TUseFocusOptions<T>> = {};
    public renderStatus: TFocusableComponentRenderStatus = FocusableComponentRenderStatus.RENDERING;

    public get isRendering(): boolean {
        return this.renderStatus === FocusableComponentRenderStatus.RENDERING;
    }

    public get isRenderedPendingMount(): boolean {
        return this.renderStatus === FocusableComponentRenderStatus.RENDERED_PENDING_MOUNT;
    }

    public get isRendered(): boolean {
        return this.renderStatus === FocusableComponentRenderStatus.RENDERED;
    }

    public get isNulled(): boolean {
        return this.renderStatus === FocusableComponentRenderStatus.NULLED;
    }
}

export default UseFocusMutableState;
